// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hig7","col":"styles_col__1xLjG"};